/* ==========================================================================
   CRONE · cx-product.js – Variantenwahl, Galerie, Sticky-Kaufleiste
   ========================================================================== */
(function () {
  'use strict';
  var CX = window.CX = window.CX || {};
  var S = CX.strings || {};

  function setup(sec) {
    if (!sec || sec._cx) return; sec._cx = 1;
    var data; try { data = JSON.parse(sec.querySelector('[data-cx-product-json]').textContent); } catch (e) { return; }
    var V = data.variants || [];
    var idInput = sec.querySelector('[data-cx-variant-id]');
    var form = sec.querySelector('[data-cx-product-form]') || (idInput && idInput.closest('form'));
    if (!form || !idInput) return;
    var atc = sec.querySelector('[data-cx-atc]'), atcLabel = sec.querySelector('[data-cx-atc-label]');
    var colorPos = +sec.dataset.colorPos || 0, sizePos = +sec.dataset.sizePos || 0;
    var fieldsets = Array.prototype.slice.call(sec.querySelectorAll('[data-cx-opt]'));
    var sticky = sec.querySelector('[data-cx-sticky]');
    var gallery = sec.querySelector('[data-cx-gallery-track]');
    var items = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.cx-gallery__item')) : [];

    function selected() {
      return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function match(opts) {
      return V.filter(function (v) { return opts.every(function (o, i) { return o === null || v.options[i] === o; }); });
    }
    function exact(opts) { if (opts.some(function (o) { return o === null; })) return null; return match(opts)[0] || null; }

    /* Galerie nach Farbe gruppieren */
    var colorStarts = [];
    if (colorPos) {
      var seen = {};
      V.forEach(function (v) { var c = v.options[colorPos - 1]; if (v.mpos && (!seen[c] || v.mpos < seen[c])) seen[c] = v.mpos; });
      Object.keys(seen).forEach(function (c) { colorStarts.push({ c: c, p: seen[c] }); });
      colorStarts.sort(function (a, b) { return a.p - b.p; });
    }
    function groupOf(pos) { var g = null; colorStarts.forEach(function (s) { if (pos >= s.p) g = s.c; }); return g; }
    /* Nur Puppen-Fotos (data-doll="1", Hochformat 3:4): gibt es in der Gruppe mindestens eines,
       fallen die Model-Fotos (data-doll="0") weg. Videos u. Ä. (data-doll="") bleiben. Sonst alles wie bisher. */
    function isDoll(it) { return it.dataset.doll === '1'; }
    function dollOnly(list) {
      if (!list.some(isDoll)) return list;
      return list.filter(function (it) { return it.dataset.doll !== '0'; });
    }
    function showOnly(list) { items.forEach(function (it) { it.hidden = list.indexOf(it) < 0; }); }
    function showGallery(color) {
      if (!items.length) return;
      if (!colorStarts.length || !color) { showOnly(dollOnly(items)); dots(); fill(color); return; }
      var any = false, first = null;
      var dolls = items.some(function (it) { return groupOf(+it.dataset.position) === color && isDoll(it); });
      items.forEach(function (it) {
        var g = groupOf(+it.dataset.position);
        var show = (g === null || g === color) && !(dolls && it.dataset.doll === '0');
        it.hidden = !show;
        if (show) { any = true; if (!first && g === color) first = it; }
      });
      if (!any) showOnly(dollOnly(items));
      var main = first || items.filter(function (it) { return !it.hidden; })[0];
      if (main) gallery.insertBefore(main, gallery.firstChild);
      gallery.classList.remove('is-swap'); void gallery.offsetWidth; gallery.classList.add('is-swap');
      if (gallery.scrollTo) gallery.scrollTo({ left: 0, behavior: 'auto' });
      dots(); fill(color);
    }

    /* Füllkachel: bei ungerader Bildanzahl bleibt rechts kein Loch, sondern das Leder aus der Nähe */
    var fillEl = sec.querySelector('[data-cx-gallery-fill]');
    var lensMap = null;
    try { var lj = sec.querySelector('[data-cx-lens-json]'); if (lj) lensMap = JSON.parse(lj.textContent); } catch (e) { lensMap = null; }
    function fill(color) {
      var vis = items.filter(function (it) { return !it.hidden; });
      vis.forEach(function (it, i) {
        var c = it.querySelector('.cx-gallery__count');
        if (!c) { c = document.createElement('span'); c.className = 'cx-gallery__count'; c.setAttribute('aria-hidden', 'true'); it.appendChild(c); }
        c.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(vis.length).padStart(2, '0');
      });
      if (!fillEl) return;
      var odd = vis.length % 2 === 1 && vis.length > 1;
      fillEl.hidden = !odd;
      if (!odd) return;
      gallery.appendChild(fillEl);
      var d = lensMap && color ? lensMap[color] : null;
      var tex = fillEl.querySelector('[data-cx-fill-tex]');
      var hasTex = !!(d && d.t);
      fillEl.classList.toggle('cx-gallery__fill--tex', hasTex);
      tex.style.backgroundImage = hasTex ? 'url(' + d.t + ')' : '';
      tex.classList.toggle('is-zoom', !!(d && d.z));
      tex.hidden = !hasTex;
      var k = fillEl.querySelector('[data-cx-fill-k]'), t = fillEl.querySelector('[data-cx-fill-t]'), dd = fillEl.querySelector('[data-cx-fill-d]'), list = fillEl.querySelector('[data-cx-fill-list]');
      if (!fillEl._k) { fillEl._k = k.textContent; fillEl._t = t.textContent; }
      if (d && (d.m || d.d)) {
        k.textContent = d.m || fillEl._k; t.textContent = color; dd.textContent = d.d || ''; dd.hidden = !d.d; list.hidden = true;
      } else {
        k.textContent = fillEl._k; t.textContent = fillEl._t; dd.hidden = true; list.hidden = false;
      }
    }
    var dotsEl = sec.querySelector('[data-cx-gallery-dots]');
    function dots() {
      if (!dotsEl) return;
      var vis = items.filter(function (it) { return !it.hidden; });
      dotsEl.innerHTML = vis.length > 1 ? vis.map(function (_, i) { return '<i' + (i === 0 ? ' class="is-on"' : '') + '></i>'; }).join('') : '';
    }
    if (gallery) gallery.addEventListener('scroll', function () {
      if (!dotsEl) return; var vis = items.filter(function (it) { return !it.hidden; });
      var i = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth * 0.86));
      Array.prototype.forEach.call(dotsEl.children, function (d, k) { d.classList.toggle('is-on', k === i); });
    }, { passive: true });

    /* Vollbild-Ansicht: Klick aufs Bild öffnet alle Bilder der Farbe untereinander, Zoom folgt der Maus */
    var zoom = null;
    function openZoom(startItem) {
      var vis = items.filter(function (it) { return !it.hidden && it.querySelector('img'); });
      if (!vis.length) return;
      if (!zoom) {
        zoom = document.createElement('div');
        zoom.className = 'cx-zoom'; zoom.setAttribute('role', 'dialog'); zoom.setAttribute('aria-modal', 'true'); zoom.setAttribute('aria-label', S.zoomLabel || 'Bilder');
        zoom.innerHTML = '<button type="button" class="cx-zoom__close" aria-label="' + (S.close || 'Schließen') + '"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19"/></svg></button><div class="cx-zoom__track"></div><div class="cx-zoom__rail" aria-hidden="true"></div>';
        document.body.appendChild(zoom);
        zoom.querySelector('.cx-zoom__close').addEventListener('click', closeZoom);
        document.addEventListener('keydown', function (e) {
          if (!zoom.classList.contains('is-open')) return;
          if (e.key === 'Escape') { closeZoom(); return; }
          if (e.key === 'Tab') { e.preventDefault(); zoom.querySelector('.cx-zoom__close').focus(); }
          var track = zoom.querySelector('.cx-zoom__track');
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ top: track.clientHeight, behavior: 'smooth' }); }
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ top: -track.clientHeight, behavior: 'smooth' }); }
        });
        zoom.addEventListener('click', function (e) {
          var f = e.target.closest('.cx-zoom__fig'); if (!f) return;
          if (window.matchMedia('(hover: none)').matches) return;
          f.classList.toggle('is-z'); if (f.classList.contains('is-z')) pan(f, e);
        });
        zoom.addEventListener('mousemove', function (e) { var f = e.target.closest('.cx-zoom__fig.is-z'); if (f) pan(f, e); });
        zoom.querySelector('.cx-zoom__rail').addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          var f = zoom.querySelectorAll('.cx-zoom__fig')[+b.dataset.i]; if (f) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        zoom.querySelector('.cx-zoom__track').addEventListener('scroll', railSync, { passive: true });
      }
      var track = zoom.querySelector('.cx-zoom__track'), rail = zoom.querySelector('.cx-zoom__rail');
      track.innerHTML = vis.map(function (it) {
        var im = it.querySelector('img'); var src = im.currentSrc || im.src;
        var big = src.replace(/([?&])width=\d+/, '$1width=2400');
        return '<figure class="cx-zoom__fig"><img src="' + big + '" alt="' + (im.alt || '').replace(/"/g, '&quot;') + '" decoding="async"></figure>';
      }).join('');
      rail.innerHTML = vis.map(function (it, i) { var im = it.querySelector('img'); return '<button type="button" data-i="' + i + '" style="background-image:url(' + (im.currentSrc || im.src) + ')"></button>'; }).join('');
      zoom.classList.add('is-open'); document.documentElement.classList.add('cx-zoom-open');
      if (window.cxLenis && window.cxLenis.stop) window.cxLenis.stop();
      var idx = Math.max(0, vis.indexOf(startItem));
      requestAnimationFrame(function () { var f = track.children[idx]; if (f) track.scrollTop = f.offsetTop; railSync(); zoom.querySelector('.cx-zoom__close').focus(); });
      zoom._ret = startItem;
    }
    function railSync() {
      if (!zoom) return; var track = zoom.querySelector('.cx-zoom__track');
      var i = Math.round(track.scrollTop / Math.max(1, track.clientHeight));
      Array.prototype.forEach.call(zoom.querySelectorAll('.cx-zoom__rail button'), function (b, k) { b.classList.toggle('is-on', k === i); });
    }
    function pan(f, e) {
      var r = f.getBoundingClientRect(); var img = f.querySelector('img');
      var x = (e.clientX - r.left) / r.width * 100, y = (e.clientY - r.top) / r.height * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    }
    function closeZoom() {
      if (!zoom) return; zoom.classList.remove('is-open'); document.documentElement.classList.remove('cx-zoom-open');
      if (window.cxLenis && window.cxLenis.start) window.cxLenis.start();
      Array.prototype.forEach.call(zoom.querySelectorAll('.cx-zoom__fig.is-z'), function (f) { f.classList.remove('is-z'); });
      if (zoom._ret) { zoom._ret.setAttribute('tabindex', '-1'); zoom._ret.focus({ preventScroll: true }); }
    }
    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var it = e.target.closest('.cx-gallery__item'); if (!it || !it.querySelector('img')) return;
        if (window.matchMedia('(max-width: 989px)').matches && gallery._drag) return;
        openZoom(it);
      });
    }

    /* Zwei Spalten wie bei tigha: die kürzere Spalte bleibt stehen (oben bzw. an ihrem Ende),
       die längere scrollt weiter – so entsteht keine weiße Fläche neben langen Beschreibungen. */
    var info = sec.querySelector('.cx-pdp__info');
    var media = sec.querySelector('.cx-pdp__media');
    function stickTop() {
      if (!info || !media) return;
      if (window.innerWidth < 990) { info.style.top = media.style.top = ''; info.style.position = media.style.position = ''; return; }
      var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--cx-header-h')) || 80;
      var top = hh + 24;
      var short = info.offsetHeight <= media.offsetHeight ? info : media, tall = short === info ? media : info;
      var gap = short === media && sec.querySelector('[data-cx-sticky]') ? 104 : 24; /* Platz für die Kaufleiste unten */
      var room = window.innerHeight - short.offsetHeight - gap;
      short.style.position = 'sticky'; short.style.top = Math.min(top, room) + 'px';
      tall.style.position = 'relative'; tall.style.top = '0px';
    }
    if (info && media) {
      stickTop(); window.addEventListener('resize', stickTop);
      if ('ResizeObserver' in window) { var ro = new ResizeObserver(stickTop); ro.observe(info); ro.observe(media); }
      sec.addEventListener('toggle', stickTop, true);
    }

    /* Voraussichtliches Lieferdatum (nur Werktage) */
    var eta = sec.querySelector('[data-cx-eta]');
    if (eta) {
      var addWd = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
      var loc = (CX.locale || document.documentElement.lang || 'de');
      var f = function (d) { try { return d.toLocaleDateString(loc, { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return d.toLocaleDateString(); } };
      var now = new Date(), a = addWd(now, +eta.dataset.min || 1), b = addWd(now, +eta.dataset.max || 3);
      var txt = (eta.dataset.text || '[from] – [to]').replace('[from]', f(a)).replace('[to]', f(b));
      eta.querySelector('[data-cx-eta-text]').textContent = txt; eta.hidden = false;
    }

    function fmt(c) { return CX.formatMoney ? CX.formatMoney(c) : (c / 100).toFixed(2); }

    function refresh(fromUser) {
      var opts = selected();
      /* Verfügbarkeit der Werte zur aktuellen Auswahl markieren */
      fieldsets.forEach(function (fs, i) {
        Array.prototype.forEach.call(fs.querySelectorAll('input'), function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var avail = match(test).some(function (v) { return v.available; });
          var lab = fs.querySelector('label[for="' + inp.id + '"]');
          if (lab) lab.classList.toggle('is-soldout', !avail);
          /* Ausverkaufte Größen bleiben sichtbar, sind aber nicht wählbar */
          if (i === sizePos - 1) { inp.disabled = !avail; if (lab) lab.style.cursor = avail ? '' : 'not-allowed'; }
        });
        var out = fs.querySelector('[data-cx-opt-value]'); if (out) out.textContent = opts[i] || '';
      });
      var v = exact(opts);
      idInput.value = v ? v.id : '';
      if (atc) {
        var label;
        if (!v) { atc.disabled = true; label = opts.indexOf(null) > -1 ? (S.chooseSize || '') : (S.unavailable || ''); }
        else if (!v.available) { atc.disabled = true; label = S.soldOut; }
        else { atc.disabled = false; label = S.addToCart; }
        if (atcLabel) atcLabel.textContent = label;
      }
      var pv = v || match(opts.map(function (o, i) { return i === sizePos - 1 ? null : o; }))[0];
      if (pv) {
        var now = sec.querySelector('[data-cx-price-now]'), was = sec.querySelector('[data-cx-price-was]');
        if (now) now.textContent = fmt(pv.price);
        if (was) { was.hidden = !(pv.compare > pv.price); was.textContent = fmt(pv.compare); }
        var sp = sec.querySelector('[data-cx-sticky-price]'); if (sp) sp.textContent = fmt(pv.price);
        var si = sec.querySelector('.cx-sticky__img'); if (si && pv.img) { si.removeAttribute('srcset'); si.src = pv.img; }
      }
      if (v && fromUser && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
      /* Sticky-Größen spiegeln */
      if (sticky && sizePos) {
        Array.prototype.forEach.call(sticky.querySelectorAll('[data-cx-sticky-size]'), function (b) {
          var test = opts.slice(); test[sizePos - 1] = b.dataset.cxStickySize;
          var ok = match(test).some(function (x) { return x.available; });
          b.classList.toggle('is-on', opts[sizePos - 1] === b.dataset.cxStickySize);
          b.classList.toggle('is-soldout', !ok); b.disabled = !ok;
        });
      }
      return v;
    }

    function pick(pos, value, fromUser) {
      var fs = fieldsets[pos - 1]; if (!fs) return;
      var inp = Array.prototype.filter.call(fs.querySelectorAll('input'), function (x) { return x.value === value; })[0];
      if (inp && !inp.checked) { inp.checked = true; onChange(pos, fromUser); }
    }
    function onChange(pos, fromUser) {
      var opts = selected();
      if (pos === colorPos && sizePos) {
        /* Größe behalten, wenn in neuer Farbe lieferbar – sonst Auswahl zurücksetzen */
        var size = opts[sizePos - 1];
        if (size) { var v = exact(opts); if (!v || !v.available) { var si = fieldsets[sizePos - 1].querySelector('input:checked'); if (si) si.checked = false; } }
      }
      var cur = refresh(fromUser);
      if (pos === colorPos) {
        var color = selected()[colorPos - 1];
        showGallery(color);
        document.dispatchEvent(new CustomEvent('cx:color-change', { detail: { color: color, from: 'product' } }));
      }
      return cur;
    }
    fieldsets.forEach(function (fs, i) {
      fs.addEventListener('change', function () { onChange(i + 1, true); });
    });

    /* Farbe aus der Sticky-Leiste übernehmen */
    document.addEventListener('cx:color-change', function (e) {
      if (!e.detail || e.detail.from !== 'sticky' || !colorPos) return;
      pick(colorPos, e.detail.color, true);
    });

    /* Sticky-Kaufleiste */
    if (sticky) {
      sticky.addEventListener('click', function (e) {
        var sz = e.target.closest('[data-cx-sticky-size]');
        if (sz) { pick(sizePos, sz.dataset.cxStickySize, true); return; }
        if (e.target.closest('[data-cx-sticky-add]')) {
          var v = exact(selected());
          if (!v) { if (window.CX.toast) CX.toast(S.chooseSize); var fs = fieldsets[sizePos - 1]; if (fs) { fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); fs.classList.add('is-hint'); setTimeout(function () { fs.classList.remove('is-hint'); }, 1600); } return; }
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
      var target = sec.querySelector('.cx-pdp__buy');
      if (target && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          Array.prototype.forEach.call(sticky.querySelectorAll('button'), function (b) { b.tabIndex = show ? 0 : -1; });
        });
        io.observe(target);
      }
    }

    /* Hinweis, wenn ohne Größe abgeschickt wird */
    form.addEventListener('submit', function (e) {
      if (!idInput.value) { e.preventDefault(); e.stopImmediatePropagation(); if (CX.toast) CX.toast(S.chooseSize); var fs = fieldsets[sizePos - 1]; if (fs) { fs.classList.add('is-hint'); setTimeout(function () { fs.classList.remove('is-hint'); }, 1600); } }
    }, true);
    document.addEventListener('cx:cart-updated', function (e) {
      if (!atc || !e.detail || !e.detail.added) return;
      atc.classList.add('is-added'); if (atcLabel) { var l = atcLabel.textContent; atcLabel.textContent = S.added || '✓'; setTimeout(function () { atcLabel.textContent = l; atc.classList.remove('is-added'); }, 1800); }
    });

    /* Start */
    var startColor = colorPos ? selected()[colorPos - 1] : null;
    refresh(false);
    showGallery(startColor);
    if (startColor) document.dispatchEvent(new CustomEvent('cx:color-change', { detail: { color: startColor, from: 'product' } }));
  }

  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-cx-product]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
